import React, { useMemo, useRef } from 'react';

import useApi from '@/hooks/useApi';

import { dispatchInteraction } from '@/services/requests/Interactions/helpers';
import { TInteractionMoreInfo } from '@/services/requests/Interactions/types';

import { getVisibleCardsIdByElement } from '@/helpers/HtmlHelper/getVisibleCardsIdByElement';
import { getValue } from '@/helpers/GetValueHelper';

import { TFooterAreasProps } from './types';

export function Footer({
  data: { id, footer_text, more_info },
}: TFooterAreasProps) {
  const { Api } = useApi();
  const containerRef = useRef<HTMLDivElement>(null);

  async function handleMoreInfoClick() {
    await dispatchInteraction<TInteractionMoreInfo>(Api, 'more-info', {
      recommendationId: id,
      cards: getVisibleCardsIdByElement(
        containerRef.current as HTMLElement,
        'more-info',
      ),
    });
  }

  const isShow = useMemo(() => {
    return footer_text || getValue(more_info, 'label', '');
  }, [more_info, footer_text]);

  const link = useMemo(() => {
    return getValue(more_info, 'link', '');
  }, [more_info]);

  return isShow ? (
    <div
      className="vitrine-template2__footer"
      data-testid="footer"
      ref={containerRef}
    >
      <p className="vitrine-template2__footer--description">{footer_text}</p>
      <div className="vitrine-template2__footer--more_information">
        <a
          href={link}
          title={getValue(more_info, 'label', '')}
          target="_blank"
          rel="noreferrer"
          onClick={handleMoreInfoClick}
        >
          <strong>{getValue(more_info, 'label', '')}</strong>
        </a>
      </div>
    </div>
  ) : (
    <></>
  );
}
